module.exports = __webpack_public_path__ + "assets/img/COUPLE3.99421660.png";